import request from './request';

const geojson = {
	async getGeojsonByFloorAndBuildingId(query) {
		const response = await request.get('/app/buildings/geojson', query);
		return response;
	}
};

export default geojson;